import { render } from "./TopButtonComponent.vue?vue&type=template&id=768b8be4&scoped=true&ts=true"
import script from "./TopButtonComponent.vue?vue&type=script&lang=ts"
export * from "./TopButtonComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/TCD-GIFTSHOP-CHANNELING-FRONT/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768b8be4"]])

export default __exports__